import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Min, Scale, Subtract, Total } from "@pdfking/math"
import { MM } from "@pdfking/quantity"

import type { CalendarArea, CalendarBoxes } from "#internal"

import { Slice } from "../layout/Slice"
import { Area } from "./Area"
import { Region } from "./Region"

// The gap between the band and the months under it
const GAP = MM(1.5)

/** A pocket calendar's band of picture across the head of its `page`, `share`
 * of it tall, the year on it; and the security frame's part under it, a
 * little way below. */
export const PocketBand = (
  { outer, page, year }: Pick<CalendarBoxes, "outer" | "page" | "year">,
  share: number
): { areas: CalendarArea[]; below: SpatialRectangle<Distance> } => {
  const band = Region(page, 0, 1 - share, 1, 1)
  const height = Scale(band.height, 0.4)
  return {
    areas: [
      Area.titled(
        band,
        "year",
        {
          ...outer,
          height,
          // Mid band, or as high as the security frame lets it
          y: Min(
            Total(band.y, Scale(Subtract(band.height, height), 0.5)),
            Subtract(Total(outer.y, outer.height), height)
          ),
        },
        `${year}`
      ),
    ],
    below: Slice.under(outer, band.y, GAP),
  }
}
